<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-data-table
          :headers="formNameHeader"
          :items="formNames"
          sort-by="name"
          class="capitalize "
        >
          <!--eslint-disable -->
          <template v-slot:top>
            <v-toolbar flat>
              <v-dialog v-model="formNameDialog" max-width="850px">
                <v-card>
                  <v-card-title>
                    <span class="text-h5">Edit Display Name</span>
                  </v-card-title>
                  <v-card-text>
                    <v-form v-model="valid" ref="contentTypeForm">
                      <v-container>
                        <v-row>
                          <v-col cols="6" sm="6">
                            <v-text-field
                              v-model="editedFormName.displayName"
                              label="name"
                              :rules="required"
                            />
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-form>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      color="red darken-1"
                      class="custom-button"
                      text
                      @click="closeaddformNameDialog"
                    >
                      Cancel
                    </v-btn>

                    <v-btn
                      color="blue darken-1 white--text"
                      class="custom-button"
                      @click="submitData"
                      :disabled="!valid || addformNameLoading"
                    >
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  class="mr-2"
                  v-bind="attrs"
                  v-on="on"
                  @click="editformName(item)"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span>Edit</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import  FormName  from "../../../settings/models/FormName";

export default {
  data() {
    return {
      editedFormName: new FormName(),
      formNameDialog: false,
      addformNameLoading: false,
      confirmationMessage: "",
      confirmationDialogDelete: false,
      loading: false,
      valid: false,
      required: [(v) => !!v || "this field is required"],
      formNameHeader: [
        {
          text: "Name",
          align: "start",
          sortable: false,
          value: "name",
        },
         {
          text: "Display Name",
          align: "start",
          sortable: false,
          value: "displayName",
        },
        {
          text: "Creation Date",
          align: "start",
          sortable: false,
          value: "creationDate",
        },

        { text: "Actions", align: "center", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    ...mapGetters("contentManagement", ["formNames"])
  },

  methods: {
    closeaddformNameDialog() {
      this.formNameDialog = false;
      this.editedFormName = Object.assign({}, new FormName());
      this.editedIndex = -1;
    },
    async submitData() {
      if (this.editedFormName?.id) {
        await this.$store.dispatch(
          "contentManagement/updateFormName",
          this.editedFormName
        );
      }
      this.closeaddformNameDialog();
    },

    closeConfirmationDialog() {
      this.confirmationDialogDelete = false;
    },
    editformName(item) {
      this.formNameDialog = true;
      this.editedFormName = item;
    },
  },
};
</script>
<style>
.custom-button {
  border-radius: 3.125rem;
}
.v-data-table {
  font-size: large;
  color: black;
}
</style>
